export default __webpack_public_path__ + "static/media/logo-patrick-roberto-ecriture-white.1ea347af.png";